module.exports = __webpack_public_path__ + "static/img/company_h.a30c6f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/company_h.png
// module id = HsGM
// module chunks = 1